module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"name":"Имя","id":"ID","projectid":"ID проекта","network":"Имя сети","networkid":"ID сети","pool":"Пул подсети","price":"Цена","ip":"Версия IP","cidr":"CIDR","poolip":"Пулы назначения IP","gateway":"IP шлюза","dhcp":"Разрешен DHCP","additional":"Дополнительные маршруты","dns":"DNS-серверы"}}')
  delete Component.options._Ctor
}
